module.exports = __webpack_public_path__ + "img/release_bannse.6528d33f.png";